// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__ggYvH","spinner":"styles_spinner__cC9CF","spinnerDark":"styles_spinnerDark__HMljy"};